import { ActionType, getType } from 'typesafe-actions';

import * as memberActions from '../actionCreators/member';
import * as currentOrderActions from '../actionCreators/currentOrder';

const initialState = null;

export default function (
  state: Member | null = initialState,
  action: ActionType<typeof memberActions | typeof currentOrderActions>,
): Member | null {
  switch (action.type) {
    case getType(currentOrderActions.resetOrder): {
      const { preserveMember } = action.payload;
      return preserveMember ? state : initialState;
    }
    case getType(memberActions.setMemberData): {
      const { value } = action.payload;
      return value == null ? initialState : value;
    }
    default:
      return state;
  }
}
